// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #1a1a2e;
  color: #fff;
}

.error-content {
  text-align: center;
  padding: 2rem;
  max-width: 500px;
}

.error-icon {
  color: #ff6b6b;
  margin-bottom: 1.5rem;
}

h1 {
  font-size: 2rem;
  margin-bottom: 1rem;
  color: #fff;
}

.error-message {
  color: #aaa;
  font-size: 1.1rem;
  margin-bottom: 2rem;
  line-height: 1.6;
}

.retry-status {
  margin-bottom: 1.5rem;
  min-height: 24px;
}

.retrying {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: #888;
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #444;
  border-top-color: #888;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.retry-button {
  background: #4a4a6a;
  color: #fff;
  border: none;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;
}
.retry-button:hover {
  background: #5a5a7a;
}`, "",{"version":3,"sources":["webpack://./src/app/components/error/error.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,qBAAA;AACF;;AAEA;EACE,eAAA;EACA,mBAAA;EACA,WAAA;AACF;;AAEA;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,qBAAA;EACA,gBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kCAAA;AACF;;AAEA;EACE;IACE,yBAAA;EACF;AACF;AAEA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA;AAAF;AAEE;EACE,mBAAA;AAAJ","sourcesContent":[".error-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: #1a1a2e;\n  color: #fff;\n}\n\n.error-content {\n  text-align: center;\n  padding: 2rem;\n  max-width: 500px;\n}\n\n.error-icon {\n  color: #ff6b6b;\n  margin-bottom: 1.5rem;\n}\n\nh1 {\n  font-size: 2rem;\n  margin-bottom: 1rem;\n  color: #fff;\n}\n\n.error-message {\n  color: #aaa;\n  font-size: 1.1rem;\n  margin-bottom: 2rem;\n  line-height: 1.6;\n}\n\n.retry-status {\n  margin-bottom: 1.5rem;\n  min-height: 24px;\n}\n\n.retrying {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #888;\n}\n\n.spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid #444;\n  border-top-color: #888;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.retry-button {\n  background: #4a4a6a;\n  color: #fff;\n  border: none;\n  padding: 0.75rem 2rem;\n  font-size: 1rem;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background 0.2s;\n\n  &:hover {\n    background: #5a5a7a;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
